module.exports = __webpack_public_path__ + "img/financialreview.c2663798.png";